import { render, staticRenderFns } from "./thermodynamicScale.vue?vue&type=template&id=2c211339&scoped=true"
import script from "./thermodynamicScale.vue?vue&type=script&lang=js"
export * from "./thermodynamicScale.vue?vue&type=script&lang=js"
import style0 from "./thermodynamicScale.vue?vue&type=style&index=0&id=2c211339&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c211339",
  null
  
)

export default component.exports